import { type Board } from '@air/api/types';

import { type CentralizedClipBoard } from '~/store/centralizedClip/types';

type KnownBoard = Pick<Board, 'id' | 'title'> &
  Partial<Pick<Board, 'ancestors' | 'thumbnails'>> & { openCommentCount?: number };

export const toCentralizedClipBoard = (board: KnownBoard): CentralizedClipBoard => ({
  ancestors: board.ancestors ?? [],
  id: board.id,
  openCommentCount: board.openCommentCount,
  thumbnails: board.thumbnails ?? [],
  title: board.title,
});
